import {
  deleteAction,
  getAction,
  putAction,
  postAction
} from '@/api/manage'
import {
  service
} from '@/utils/request'
import axios from "axios";
//登录
export const syslogin = (params) => postAction("/gkUser/login", params);
//获取验证码

export const syssms = (params) => postAction("/sys/login", params);

//获取用户信息
export const selectUserInfo = (params) => getAction("/gkUser/queryById", params);
//根据分数、年份查询位次
export const selectCommonSpringPrecedence =  (params) => getAction("/gkUser/getCommonSpringExamRank", params);

export const selectAuditionPePrecedence = (params) => getAction("/gkUser/getAuditionPeExamRank", params);


export const selectPrecedence = (params) => getAction("/examination/fore/selectPrecedence", params);


export const getAuditionPeExamRank = async (score, examType, gkYear, auditionType) => {
  try {
    return await axios.get(Api.getAuditionPeExamRank, {
      headers: {
        'X-Access-Token': getToken(),
      },
      params: {
        score: score,
        examType: examType,
        gkYear: gkYear,
        auditionType: auditionType,
      },
    });
  } catch (error) {
    throw error;
  }
};
//退出
export function logout(logoutToken) {
  return service({
    url: '/gkUser/foreLogout',
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      'X-Access-Token': logoutToken
    }
  })
}